import { Skeleton } from '@mui/material'
import { useContext } from 'react'
import { useDispatch } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import BreadcrumbsArrowRight from '../../../common-images/app-logo/ArrowRight'
import { BreadcrumbContext } from '../../../contexts/BreadcrumbContext'
import { useSessionContex } from '../../../SessionContex'
type BreadcrumbsDataType = {
  label: any
  href: string
  onClick?: any
  id?: string
}

const Breadcrumbs = () => {
  const { breadcrumbData }: any = useContext(BreadcrumbContext)
  const { setServiceApi, setActiveName, reCall } = useSessionContex()

  const Navigate = useNavigate()
  const dispatch = useDispatch()
  const location = useLocation()

  return (
    <div className='breadcrumbs'>
      <div className='breadcrumbs-line' />
      <div className='breadcrumbs-options'>
        {Array.isArray(breadcrumbData) &&
          breadcrumbData?.map((data: BreadcrumbsDataType, i: number) => {
            return (
              <div
                className={`d-flex align-center
               ${
                 i === breadcrumbData.length - 1 &&
                 !data.onClick &&
                 data.label !== 'Home' &&
                 'pointer-events-none cursor-auto'
               }`}
                key={i}
                onClick={e => {
                  e.stopPropagation()
                  Navigate(data.href, { state: { data: {} } })
                  if (data.label === 'Home') {
                    dispatch({ type: 'SET_DEVICE_ACTIVE_TAB_REQUEST', payload: 0 })
                  }

                  if (data?.id === 'email') {
                    dispatch({ type: 'SET_DEVICE_ACTIVE_TAB_REQUEST', payload: 0 })
                    setActiveName('Overview')
                  }

                  if (i === breadcrumbData.length - 3) {
                    localStorage.removeItem('isPCverified')
                    setServiceApi(false)
                  }
                }}
              >
                <p className='breadcrumbs-option'>
                  {reCall && i === breadcrumbData.length - 1 && location.pathname.includes('/dashboard') ? (
                    <Skeleton variant='text' className='info-desc-cls' animation='wave' width={80} height={18} />
                  ) : (
                    data.label
                  )}
                </p>{' '}
                {i <= breadcrumbData.length - 2 && <BreadcrumbsArrowRight />}
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default Breadcrumbs
